import { addRootClass, calculateWindowSize, removeRootClass } from "@/utils/helpers";
import { defineStore } from "pinia";
import { useAPIStore } from "./APIStore";
import { useAuthStore } from "./AuthStore";

export const useUIStore = defineStore('uiStore', {
  state: () => ({
      authentication: '',
      appName: 'Rituals IT-App',
      user: {
        firstName: '',
        lastName: '',
        role: '',
        email: '',
      },
      darkMode: false,
      navbarVariant: 'navbar-dark',
      sidebarSkin: 'sidebar-dark-olive',
      menuSidebarCollapsed: false,
      controlSidebarCollapsed: true,
      screenSize: calculateWindowSize(window.innerWidth),
      sidebarHeight: 0,
      sidebarPinned: false,
      currentLicense: null,

      showTicketChangeChatSidebar: false,
      showNotificationSidebar: false,
      showLicenseSidebar: false,

      enabledProfileMenu: false,
      enabledGlassIcon: false,
      enabledPopupMenu: false,

      shiftPressed: false,
      infoBannerContent: null,
      infoBannerActionButtonContent: null,
      infoBannerActionButtonAction: null,
      unsavedChanges: false,
      showUnsavedChangesProtection: false,
      unsavedChangesProtectedURL: null,
      showCameraSnapshot: false,
      showElevatedSessionPopup: false,
      showMagicLinkPopup: false,
      showPermissionsConfirmPopup: false,
      permissionsConfirmMode: null,
      permissionsConfirmPermissions: null,
      resolvePermissionsConfirmPopup: null,
      rejectPermissionsConfirmPopup: null,
      windowTooSmall: false,
  }),
  actions: {
    enablePermissionsConfirmPopup() {
      addRootClass("no-scroll")
      this.showPermissionsConfirmPopup = true
    },
    disablePermissionsConfirmPopup(){
      removeRootClass("no-scroll")
      this.showPermissionsConfirmPopup = false
    },
    enableElevatedSessionPopup() {
      this.showElevatedSessionPopup = true
    },
    disableElevatedSessionPopup(reject = true){
      if(reject){
        const AuthStore = useAuthStore()
        AuthStore.rejectElevatedSession()
      }
      this.showElevatedSessionPopup = false
    },
    enableMagicLinkPopup() {
      this.showMagicLinkPopup = true
    },
    disableMagicLinkPopup(){
      this.showMagicLinkPopup = false
    },
    toggleMenuSidebar() {
      this.menuSidebarCollapsed = !this.menuSidebarCollapsed
    },
    enableShowCameraSnapshot() {
      addRootClass("no-scroll")
      this.showCameraSnapshot = true
    },
    disableShowCameraSnapshot() {
      removeRootClass("no-scroll")
      const APIStore = useAPIStore()
      this.showCameraSnapshot = false
      APIStore.imageSnapshot = null
    },
    setWindowSize(payload: any) {
      this.screenSize = payload
    },
    enableNotificationSidebar(){
      this.disableSidebars()
      addRootClass("no-scroll")
      this.showNotificationSidebar = true
    },
    enableLicenseSidebar(){
      this.disableSidebars()
      addRootClass("no-scroll")
      this.showLicenseSidebar = true
    },
    enableTicketChangeChatSidebar(){
      this.disableSidebars()
      addRootClass("no-scroll")
      this.showTicketChangeChatSidebar = true
    },
    disableNotificationSidebar(){
      removeRootClass("no-scroll")
      this.showNotificationSidebar = false
    },
    disableLicenseSidebar(){
      removeRootClass("no-scroll")
      this.showLicenseSidebar = false
    },
    disableTicketChangeChatSidebar(){
      removeRootClass("no-scroll")
      this.showTicketChangeChatSidebar = false
    },
    disableSidebars(){
      this.disableNotificationSidebar()
      this.disableLicenseSidebar()
      this.disableTicketChangeChatSidebar()
    },
    closeAllMenus(){
      this.enabledProfileMenu = false
      this.enabledGlassIcon = false
      this.enabledPopupMenu = false
    },
    setUnsavedChanges(action){
      this.infoBannerContent = "You have unsaved changes"
      this.infoBannerActionButtonContent = "Save Changes"
      this.infoBannerActionButtonAction = action
      this.unsavedChanges = true
    },
    releaseUnsavedChanges(){
      this.infoBannerContent = null
      this.infoBannerActionButtonContent = null
      this.infoBannerActionButtonAction = null
      this.unsavedChanges = false
    },
    async toggleConfirmPermissions(){
      this.enablePermissionsConfirmPopup()
      let confirm = null
      try{
        await new Promise((resolve, reject) => {
          this.resolvePermissionsConfirmPopup = resolve;
          this.rejectPermissionsConfirmPopup = reject;
        })
        confirm = true
      }catch{
        confirm = false
      }finally{
        this.disablePermissionsConfirmPopup()
      }
      return confirm
		},
    async rejectPermissionChange(){
      this.rejectPermissionsConfirmPopup()
      this.rejectPermissionsConfirmPopup = null
      this.disablePermissionsConfirmPopup()
    },
    async resolvePermissionChange(){
      this.resolvePermissionsConfirmPopup()
      this.resolvePermissionsConfirmPopup = null
      this.disablePermissionsConfirmPopup()
    }
  }
})
